import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "l-header" }
const _hoisted_2 = { class: "ha-header" }
const _hoisted_3 = { class: "ha-header__container" }
const _hoisted_4 = { class: "ha-header__service" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ha-header__brand" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ha-header__shlogo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "SHUEISHA ID"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siteLogoInfos, (siteLogoInfo, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: _normalizeClass(_ctx.siteLogoInfos.length > 1 ? 'ha-header__halogo_multi' : 'ha-header__halogo')
            }, [
              (_ctx.isEnabledLogoLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    tabindex: "-1",
                    href: siteLogoInfo.url
                  }, [
                    _createElementVNode("img", {
                      src: siteLogoInfo.logoUrl,
                      alt: siteLogoInfo.altName
                    }, null, 8, _hoisted_6)
                  ], 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: siteLogoInfo.logoUrl,
                    alt: siteLogoInfo.altName
                  }, null, 8, _hoisted_7))
            ], 2))
          }), 128))
        ]),
        _hoisted_8
      ])
    ])
  ]))
}